// This file is generated by assets/update.ts - DO NOT EDIT MANUALLY
// Run 'bun assets/update.ts' to regenerate this file

import { resolveBundledFilePath } from "../../platform/runtime.js"

interface FileImportModule {
  readonly default: string
}

const bundledAssetLoaders: Record<string, () => Promise<FileImportModule>> = {
  "assets/javascript/highlights.scm": () =>
    import("./assets/javascript/highlights.scm" as string, { with: { type: "file" } }),
  "assets/javascript/tree-sitter-javascript.wasm": () =>
    import("./assets/javascript/tree-sitter-javascript.wasm" as string, { with: { type: "file" } }),
  "assets/typescript/highlights.scm": () =>
    import("./assets/typescript/highlights.scm" as string, { with: { type: "file" } }),
  "assets/typescript/tree-sitter-typescript.wasm": () =>
    import("./assets/typescript/tree-sitter-typescript.wasm" as string, { with: { type: "file" } }),
  "assets/markdown/highlights.scm": () =>
    import("./assets/markdown/highlights.scm" as string, { with: { type: "file" } }),
  "assets/markdown/tree-sitter-markdown.wasm": () =>
    import("./assets/markdown/tree-sitter-markdown.wasm" as string, { with: { type: "file" } }),
  "assets/markdown/injections.scm": () =>
    import("./assets/markdown/injections.scm" as string, { with: { type: "file" } }),
  "assets/markdown_inline/highlights.scm": () =>
    import("./assets/markdown_inline/highlights.scm" as string, { with: { type: "file" } }),
  "assets/markdown_inline/tree-sitter-markdown_inline.wasm": () =>
    import("./assets/markdown_inline/tree-sitter-markdown_inline.wasm" as string, { with: { type: "file" } }),
  "assets/zig/highlights.scm": () => import("./assets/zig/highlights.scm" as string, { with: { type: "file" } }),
  "assets/zig/tree-sitter-zig.wasm": () =>
    import("./assets/zig/tree-sitter-zig.wasm" as string, { with: { type: "file" } }),
}

export function resolveBundledDefaultParserAsset(relativePath: string, fallbackPath: URL): Promise<string> {
  const loadBundledFile = bundledAssetLoaders[relativePath]
  if (!loadBundledFile) {
    throw new Error(`Unknown OpenTUI default parser asset: ${JSON.stringify(relativePath)}`)
  }
  return resolveBundledFilePath(`@opentui/core/${relativePath}`, loadBundledFile, fallbackPath, import.meta.url)
}
